'use client';

import { FC, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { ChevronLeft, Check } from 'lucide-react';
import { useAppSelector } from '@/hotdesk-ui/hooks/hook';
import { RootState } from '@/hotdesk-ui/store/store';
import { AuthPopupService } from '@/hotdesk-ui/services/authPopup.service';
import { tracking } from '@/hotdesk-ui/services/tracking.service';
import './NoWorkspace.scss';
const SAD_MORPHY_ICON = '/assets/icons/morphy/sad-morphy.svg';
const CONTAINER_ICON = '/assets/icons/container.svg';
const Illustration: FC = () => <div className="noWorkspace__illustration" data-sentry-component="Illustration" data-sentry-source-file="NoWorkspace.tsx">
        <img src={SAD_MORPHY_ICON} alt="" width={124} height={157} className="noWorkspace__illoIcon" />
    </div>;
export const NoWorkspace: FC = () => {
  const t = useTranslations('explore.no-workspace');
  const router = useRouter();
  const user = useAppSelector((s: RootState) => s.auth.user);
  const geoLocation = useAppSelector((s: RootState) => s.geoLocation.geoLocationZipData);
  const filters = useAppSelector((s: RootState) => s.listing.filters);
  const [requested, setRequested] = useState(false);
  const isSignedIn = !!user;
  const handleRequest = () => {
    const screenUrl = typeof window !== 'undefined' ? window.location.pathname + window.location.search : '';
    tracking.onWorkspaceRequestSubmitted(geoLocation, filters, screenUrl, user?.email);
    setRequested(true);
  };
  const handleLogin = () => {
    new AuthPopupService().getPopup();
  };
  const handleBack = () => {
    router.push('/workspaces?active=workspace');
  };
  const BackLink = <button type="button" className="noWorkspace__backLink" onClick={handleBack}>
            <ChevronLeft size={14} />
            <span>{t('backLink')}</span>
        </button>;
  return <div className="noWorkspace" data-sentry-component="NoWorkspace" data-sentry-source-file="NoWorkspace.tsx">
            <Illustration data-sentry-element="Illustration" data-sentry-source-file="NoWorkspace.tsx" />
            <h3 className="noWorkspace__title">{t('signedInTitle')}</h3>
            <p className="noWorkspace__desc">{t('signedInDesc')}</p>

            {!isSignedIn ? <button type="button" className="noWorkspace__primaryBtn" onClick={handleLogin}>
                    <span className="noWorkspace__primaryBtnLabel">
                        {t('signedOutCta')}
                    </span>
                </button> : !requested ? <button type="button" className="noWorkspace__primaryBtn noWorkspace__primaryBtn--withIcon" onClick={handleRequest}>
                    <span className="noWorkspace__primaryBtnIcon">
                        <img src={CONTAINER_ICON} alt="" width={20} height={20} />
                    </span>
                    <span className="noWorkspace__primaryBtnLabel">
                        {t('requestCta')}
                    </span>
                </button> : <button type="button" className="noWorkspace__primaryBtn noWorkspace__primaryBtn--confirmed" disabled aria-live="polite">
                    <span className="noWorkspace__primaryBtnIcon noWorkspace__primaryBtnIcon--confirmed">
                        <Check size={12} color="#ffffff" />
                    </span>
                    <span className="noWorkspace__primaryBtnLabel">
                        {t('requestConfirmed')}
                    </span>
                </button>}

            {BackLink}

            {isSignedIn && requested && <div className="noWorkspace__toast" role="status">
                    {t('requestToast')}
                </div>}
        </div>;
};
export default NoWorkspace;